export * from './user.service'
export * from './data.service'



// WEBPACK FOOTER //
// ./src/_services/index.js